import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/comment-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M448 0H64C28.7 0 0 28.7 0 64V352C0 387.3 28.7 416 64 416H160V500C160 507.1 165.8 512 172 512 174.4 512 176.9 511.3 179.1 509.6L304 416H448C483.3 416 512 387.3 512 352V64C512 28.7 483.3 0 448 0zM464 352C464 360.8 456.8 368 448 368H288L275.2 377.6 208 428V368H64C55.2 368 48 360.8 48 352V64C48 55.2 55.2 48 64 48H448C456.8 48 464 55.2 464 64V352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/comment-alt.js
// module id = /qvm
// module chunks = 144